// Module Federation loads shared modules (react, react-dom, ...) asynchronously.
// A synchronous import here fails with "Shared module is not available for eager
// consumption", so the real entry point is behind a dynamic import.
// This keeps `npm start` (federated) and `npm run start:standalone` both working.
import("./standalone");

export {};
